import Splide from "@splidejs/splide";
import { PublicCommunityLI, PublicCommunityLIData }
	from "../../web/src/community/PublicCommunityLI";
import { FacebookEventLI, FacebookEventLIData } from "./FacebookEventLI";
import { AppSettings, getIndexPageUi, QueryParams }
	from "../../web/src/settings/AppSettings";
import { HttpUtils } from "ts_utils";
import { AudioPlayer } from "./audio_player/AudioPlayer";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import { FbInit } from "../../web/src/services/firebase/FbInit";
import { FbAuth } from "../../web/src/services/firebase/FbAuth";

export class IndexPage {
	private _startBtnDiv:HTMLDivElement;
	private _signinLink:HTMLDivElement;
	private _audioPlayer:AudioPlayer;
	
	private _debugDuplicateCommunities:boolean = false;
	
	constructor(){
		this._initAudioPlayer();
		if (AppSettings.allowSignin){
			this._initSigninApp();
		}
		else {
			this._initNonUserApp();
		}
	}

	private _initAudioPlayer() {
		this._audioPlayer = new AudioPlayer();
	}
	
	private async _checkAuthState():Promise<User | null> {
		await FbInit.initializeFirebase(false);
		return new Promise((resolve) => {
			let auth = getAuth();
			let unsubscribe = onAuthStateChanged(auth, (user:User | null) => {
				unsubscribe();
				resolve(user);
			}, () => {
				resolve(null);
			});
		});
	}
	
	private async _initSigninApp():Promise<void> {
		AppSettings.init();
		
		this._ensureChrome();
		
		let ui = getIndexPageUi();

		this._startBtnDiv = ui.querySelector("#stscr-startBtnDiv");
		this._signinLink = ui.querySelector("#stscr-signinLink");

		ui.classList.remove("showSigninLink");

		this._startBtnDiv.classList.add("disabled");

		this._parseQueryParams();
		this._setupCommunities();
		this._setupEvents();

		await this._checkAuthState();

		this._startBtnDiv.classList.remove("disabled");

		this._startBtnDiv.addEventListener("click", this._onStartBtnDivClick);
		if (AppSettings.allowGuests && !FbAuth.isRealUserSignedIn()){
			ui.classList.add("showSigninLink");
			this._signinLink.addEventListener("click", this._onSignInClick);
		}
		
		if (AppSettings.jumpToCheckout){
			this._onSignInClick(null);
		}
	}
	
	private _initNonUserApp():void {
		AppSettings.init();
		
		this._ensureChrome();
		
		let ui = getIndexPageUi();
		
		this._startBtnDiv = ui.querySelector("#stscr-startBtnDiv");
		this._startBtnDiv.addEventListener("click", this._onNonUserStartClick);
		
		this._parseQueryParams();
	}
	
	private _ensureChrome(){
		AppSettings.chooseBestAudioSettings();
		AppSettings.chooseBestVideoSettings();
		
		if (!AppSettings.isAudioSupported){
			let warning = document.querySelector("#stscr-audioWarning") as
				HTMLDivElement;
			warning.style.display = "block";
			
			if (AppSettings.failOnNoAudioSupport){
				let signinDiv = document.querySelector("#stscr-signinDiv") as
					HTMLDivElement;
				signinDiv.style.display = "none";
			}
		}
		else if (!AppSettings.isVideoSupported){
			let warning = document.querySelector("#stscr-videoWarning") as
				HTMLDivElement;
			warning.style.display = "block";
			
			if (AppSettings.failOnNoVideoSupport){
				let signinDiv = document.querySelector("#stscr-signinDiv") as
					HTMLDivElement;
				signinDiv.style.display = "none";
			}
		}
	}
	
	private _parseQueryParams(){
		let queryParams = HttpUtils.parseQueryString(window.location.search) as
			QueryParams;
		
		window["params"].queryParams = queryParams;
		
		if (Object.keys(queryParams).length > 0){
			let newUrl = window.location.href.split("?")[0];
			window.history.replaceState({}, document.title, newUrl);
		}
		if (queryParams.mode === "resetPassword" ||
				queryParams.mode === "recoverEmail" ||
				queryParams.mode === "verifyEmail" ||
				queryParams.skipToSignin === "1"){
			this._onSignInClick(null);
			document.getElementById("stscr-appContainer").scrollIntoView();
		}
	}
	
	private _setupCommunities():void {
		let splideEl = document.querySelector(
			"#stscr-findACommunity .splide") as HTMLElement;
		let splide = new Splide(splideEl, {
			padding: "45px",
			autoWidth: true,
			gap: "20px",
			pagination: false,
		});
		splide.mount();

		let communities = window["publicCommunityLIData"] as
			PublicCommunityLIData[];
		if (communities.length > 0 && this._debugDuplicateCommunities){
			communities[0].name = "The Bright Trumpets Community";
			while (communities.length < 10){
				communities.push(communities[0]);
			}
		}

		let items:PublicCommunityLI[] = [];
		communities.forEach(data => {
			let li = new PublicCommunityLI(data);
			splide.add(li.ui);
			items.push(li);
		});
		window["publicCommunityListItems"] = items;

		if (communities.length < 1){
			splideEl.style.display = "none";
		}
	}

	private _setupEvents():void {
		let splideEl = document.querySelector("#stscr-facebook .splide") as
			HTMLElement;
		let splide = new Splide(splideEl, {
			padding: "45px",
			autoWidth: true,
			gap: "20px",
			pagination: false,
		});
		splide.mount();

		let events = window["facebookEventData"] as FacebookEventLIData[];

		events.forEach(data => {
			let item = new FacebookEventLI(data);
			splide.add(item.ui);
		});

		if (events.length < 1){
			splideEl.style.display = "none";
		}
	}
	
	private _onStartBtnDivClick = (e:MouseEvent) => {
		window["params"].tryAsGuest = (AppSettings.allowGuests &&
			!FbAuth.isRealUserSignedIn());
		this._removeListeners();
		this._signIn();
	}
	
	private _onSignInClick = (e:MouseEvent) => {
		window["params"].tryAsGuest = false;
		this._removeListeners();
		this._signIn();
	}
	
	private _onNonUserStartClick = (e:MouseEvent) => {
		this._removeListeners();
		this._nonUserStart();
	}
	
	private _signIn():void {
		this._audioPlayer.stop();

		let signinDiv = document.getElementById("stscr-signinDiv");
		signinDiv.classList.add("hideSigninBtns");
		
		let busyDiv = document.querySelector("#stscr-signinBusyDiv") as
			HTMLDivElement;
		busyDiv.style.display = "block";
		
		let script = document.createElement("script");
		script.type = "text/javascript";
		script.src = window["params"].resourcesUrl +
			`main.js?v=${window["params"].appVersion}`;
		document.body.append(script);
	}
	
	private _nonUserStart():void {
		this._audioPlayer.stop();

		let signinDiv = document.getElementById("stscr-signinDiv");
		signinDiv.classList.add("hideSigninBtns");
		
		let busyDiv = document.querySelector("#stscr-signinBusyDiv") as
			HTMLDivElement;
		busyDiv.style.display = "block";
		
		let script = document.createElement("script");
		script.type = "text/javascript";
		script.src = window["params"].resourcesUrl +
			`main.js?v=${window["params"].appVersion}`;
		document.body.append(script);
	}
	
	private _removeListeners():void {
		this._startBtnDiv.removeEventListener("click",
			this._onStartBtnDivClick);
		this._startBtnDiv.removeEventListener("click",
			this._onNonUserStartClick);
		this._signinLink?.removeEventListener("click", this._onSignInClick);
	}
}

new IndexPage();